import {
  FETCH_HOLIDAYS,
  FETCH_HOLIDAYS_SUCCESS,
  FETCH_HOLIDAYS_FAILURE,
  CREATE_HOLIDAY,
  CREATE_HOLIDAY_SUCCESS,
  CREATE_HOLIDAY_FAILURE,
  UPDATE_HOLIDAY,
  UPDATE_HOLIDAY_SUCCESS,
  UPDATE_HOLIDAY_FAILURE,
  DELETE_HOLIDAY,
  DELETE_HOLIDAY_SUCCESS,
  DELETE_HOLIDAY_FAILURE,
  FETCH_HOLIDAY_EMPLOYEE,
  SAVE_HOLIDAY_PROCESS,
  REMOVE_EMPLOYEE_HOLIDAY,
  RESET_HOLIDAY_EMPLOYEES,
  FETCH_HOLIDAY_PROCESS_LIST_REQUEST,
  FETCH_HOLIDAY_PROCESS_LIST_SUCCESS,
  FETCH_HOLIDAY_PROCESS_LIST_FAILURE
} from "./actionTypes";

// Fetch Holidays
export const fetchHolidays = (unitId) => ({
  type: FETCH_HOLIDAYS,
  payload: { unitId }
});

export const fetchHolidaysSuccess = (holidays) => ({
  type: FETCH_HOLIDAYS_SUCCESS,
  payload: holidays,
});

export const fetchHolidaysFailure = (error) => ({
  type: FETCH_HOLIDAYS_FAILURE,
  payload: error,
});

// Create Holiday
export const createHoliday = (formData) => ({
  type: CREATE_HOLIDAY,
  payload: {formData},
});

export const createHolidaySuccess = (holiday) => ({
  type: CREATE_HOLIDAY_SUCCESS,
  payload: holiday,
});

export const createHolidayFailure = (error) => ({
  type: CREATE_HOLIDAY_FAILURE,
  payload: error,
});

// Update Holiday
export const updateHoliday = (holiday) => ({
  type: UPDATE_HOLIDAY,
  payload: holiday,
});

export const updateHolidaySuccess = (holiday) => ({
  type: UPDATE_HOLIDAY_SUCCESS,
  payload: holiday,
});

export const updateHolidayFailure = (error) => ({
  type: UPDATE_HOLIDAY_FAILURE,
  payload: error,
});

// Delete Holiday
export const deleteHoliday = (id) => ({
  type: DELETE_HOLIDAY,
  payload: id,
});

export const deleteHolidaySuccess = (id) => ({
  type: DELETE_HOLIDAY_SUCCESS,
  payload: id,
});

export const deleteHolidayFailure = (error) => ({
  type: DELETE_HOLIDAY_FAILURE,
  payload: error,
});


export const fetchHolidayEmployee = (payload) => ({
  type: FETCH_HOLIDAY_EMPLOYEE,
  payload
});

export const saveHolidayProcess = (payload) => ({
  type: SAVE_HOLIDAY_PROCESS,
  payload,
});

export const removeEmployeeHoliday = (payload) => ({
  type: REMOVE_EMPLOYEE_HOLIDAY,
  payload,
});

export const resetHolidayEmployees = () => ({
  type: RESET_HOLIDAY_EMPLOYEES,
});

export const fetchHolidayProcessListRequest = (unit_id) => ({
  type: FETCH_HOLIDAY_PROCESS_LIST_REQUEST,
  payload:{unit_id}
});

export const fetchHolidayProcessListSuccess = (data) => ({
  type: FETCH_HOLIDAY_PROCESS_LIST_SUCCESS,
  payload: data,
});

export const fetchHolidayProcessListFailure = (error) => ({
  type: FETCH_HOLIDAY_PROCESS_LIST_FAILURE,
  payload: error,
});